<template>
  <div
    id="modalDetailQuote"
    class="modal c-modal c-modal--calculator p-0"
    tabindex="0"
    style="
      z-index: 1003;
      display: none;
      opacity: 0;
      top: 4%;
      transform: scaleX(0.8) scaleY(0.8);
    "
  >
    <div class="container" v-if="resQuote">
      <img
        v-if="showClose"
        @click="closeModal"
        class="close-btn-modal"
        src="~@/assets/img/icon/icon-closex.svg"
        style="position: absolute; top: 20px; right: 20px; cursor: pointer"
      />
      <div class="header">
        <span style=""> Detalles </span>
      </div>
      <div class="content pt-2">
        <div style="padding-bottom: 30px">
          <div class="col s12">
            <div class="row-detail" style="margin-top: 20px">
              <span style="font-weight: bolder">Detalle del pago</span>
              <span style="font-weight: bolder">S/ PEN</span>
            </div>
            <div class="row-detail">
              <span>Subtotal</span>
              <span>S/ {{ resQuote.SubTotal }}</span>
            </div>
            <div class="row-detail">
              <span>Descuento</span>
              <span>S/ {{ resQuote.couponDiscount }}</span>
            </div>
            <div class="row-detail">
              <span style="font-weight: bolder; font-family: 'Manrope'"
                >Pago total por el servicio</span
              >
              <span style="font-weight: bolder"
                >S/ {{ resQuote.totalFare }}</span
              >
            </div>
          </div>
          <div class="col s12 mt-4">
            <button
              v-on:click="handleSubmit()"
              class="c-button c-button--primary c-button--width-fuid c-button--mobile-small waves-effect"
            >
              Pagar y enviar S/ {{ resQuote.totalFare.toFixed(2) }}
            </button>
          </div>
        </div>
        <!-- <div class="pb-4" style="font-size: 0.7rem">
          <span>
            * Servicio: Consolidación en almacenes Miami, transporte
            internacional de USA a Perú, proceso de declaración y liberación
            ante la Aduana y almacenaje.
          </span>
          <br />
          <br />
          <span
            >Las tarifas son referenciales y su valor será más cercano al costo
            real entre más específica sea la información que ingreses en el
            formulario. (Precios válidos solo para los trayectos de Lima a
            provincias y de Lima a Lima)</span
          >
          <br />
          <br />
          <span
            >Si desea más información, puedes revisar nuestros
            <a
              target="popup"
              href="https://saio.holascharff.com/Files/terminos-y-condiciones-compra-y-trae.pdf"
              style="color: #ff565d"
              >Términos y condiciones</a
            ></span
          >
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";

export default {
  name: "DetailQuote",
  props: {
    resQuote: {
      required: true,
    },
    // order: {
    //   required: true,
    // },
    // destinationContact: {
    //   required: true,
    // },
    // destinationAddress: {
    //   required: true,
    // },
    // consigneeDocumentNumber: {
    //   default: ''
    // },
    showClose: {
      default: true,
    },
  },
  data() {
    return {
      // categoriesText: [],
      error: false,
    };
  },
  mounted() {},
  // computed: {
  //   categoriesText() {
  //     return this.order.categoryIds.map(
  //       (categoryId) =>
  //         this.$store.getters.COMPRATRAE_CATEGORIES_BY_ID(categoryId).text
  //     );
  //   },
  // },
  methods: {
    handleSubmit() {
      this.$eventBus.$emit("createOrder");
    },
    closeModal() {
      const modalCalculator = document.querySelector("#modalDetailQuote");
      const instance2 = M.Modal.getInstance(modalCalculator);
      instance2.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  max-height: 90vh;
  overflow-x: auto;
  position: relative;
}
.header {
  height: 120px;
  width: 100%;
  background-color: var(--g-color-first);
  border-radius: 0% 0% 80px 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: white;
    font-size: 2.5rem;
    font-weight: bolder;
  }
}

.content {
  display: flex;
  flex-direction: column;
  padding: 0px 30px;
}

.row-detail {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 2px #cfcfcf;
  margin-top: 10px;
  padding-bottom: 5px;
  &-title {
    justify-content: center;
    text-align: center;
    font-size: 1.35rem;
  }
}
</style>
